module.exports = __webpack_public_path__ + "media/images/home/costs-67500508762d8d88fdf8138130bc4622.png";